import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { API } from 'aws-amplify';
import "tabler-react/dist/Tabler.css";
import { Card, Dimmer } from "tabler-react";
import { SettingsApplicationsTwoTone } from '@material-ui/icons';

class TablaReporteActividades extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      data: [],
      actividades: [],
      foros: [],
      columns: [],
      alumnos: [],
      submissions: [],
      dataColumnas: [],
      isLoading: true,
      alumnosNotGrade: []
    });
  }

  componentDidMount = async () => {
    let submits = [];
    const docenteInfo = JSON.parse(localStorage.getItem('profile'));
    const respuestaApiActividades = await API.get('apiMisCursos', '/obtenerActividadesCurso', {
      queryStringParameters: {
        nivel: this.props.data.nivel,
        username: docenteInfo.username,
        courseId: this.props.data.cursosId
      }
    });
    
    if (respuestaApiActividades.status) {
      const respuestaApiForos = await API.get('apiMisCursos', '/obtenerForosCurso', {
        queryStringParameters: {
          nivel: this.props.data.nivel,
          username: docenteInfo.username,
          courseId: this.props.data.cursosId
        }
      });
      
      for (let index in respuestaApiActividades.data.actividades.assigns) {
        const respuestaApiAssigment = await API.get('apiMisCursos', '/obtenerAlumnosActividad', {
          queryStringParameters: {
            nivel: this.props.data.nivel,
            username: docenteInfo.username,
            assigmentId: respuestaApiActividades.data.actividades.assigns[index].id
          }
        });
        submits.push(respuestaApiAssigment);
      }

      let finalSubmits = [];
      let alumnos = this.props.alumnos.data.data.alumnos;
      for (let indexActividad in submits) {
        for (let indexSubmission in submits[indexActividad].data.submissions.assignments[0].submissions) {
          for (let indexAlumnos in alumnos) {
            if (alumnos[indexAlumnos].id === submits[indexActividad].data.submissions.assignments[0].submissions[indexSubmission].userid ) {
              submits[indexActividad].data.submissions.assignments[0].submissions[indexSubmission].isShown = true;
            }
          }  
        }
      }

      if (respuestaApiForos.status) {
        this.setState({
          actividades: respuestaApiActividades.data.actividades,
          foros: respuestaApiForos.data.foros,
          alumnos: this.props.alumnos.data.data.alumnos,  
          submissions: submits
        });
        
        this.setColumnsForTable();
        this.setStatusForTable();
      }
    }
  }

  convertUnixToDate (time) {
    const milliseconds = time * 1000
    const date = new Date(milliseconds);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    return date.toLocaleDateString( undefined, options )
  }

  setColumnsForTable () {
    let columnas = [{ title: 'Status', field: 'status', sorting: false }];
    let count = 1;
    let stringActividad = '';
    for (let index in this.state.actividades.assigns) {
      stringActividad = 'rowData.actividad_'+count;
      columnas.push({ actividadName: this.state.actividades.assigns[index].name,title: this.state.actividades.assigns[index].name+'.\n'+this.convertUnixToDate(this.state.actividades.assigns[index].duedate),
        field: 'actividad_' + count, sorting: false, render: rowData => {
        return <a onClick={() => this.handleClick(rowData.singleStatus, rowData['actividad_' + (parseInt(index) + 1)], Object.keys(rowData)[(parseInt(index) + 2)])}>{rowData['actividad_' + (parseInt(index) + 1)]}</a>
      }});
      count++;
    }
    this.setState({columns: columnas});
  }

  setStatusForTable () {
    let countAct = 1;
    let countNotGraded = 0;
    let countSubmitted = 0;
    let countNotSubmitted = 0;
    let countTotal = 0;
    let totalNoEnviadas = 0;
    let submittedData = [];
    let notSubmittedData = [];
    let notGradedData = [];
    const alumnosNotGrade = [];
    const alumnosInfo = this.state.alumnos
    let conteo = 0;
    for (const alumnos of alumnosInfo) {
      if(this.props.alumnos.curso.cursosNombres  == alumnos.cursoNombre && this.props.alumnos.curso.cursosId == alumnos.cursoId){
        conteo++;
      }
    }
    for (let indexActividad in this.state.actividades.assigns) {
      for (let indexSubmission in this.state.submissions) {
        if (this.state.actividades.assigns[indexActividad].id === this.state.submissions[indexSubmission].data.submissions.assignments[0].assignmentid) {
          for (let index in this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions) {
            let bandEnviada = 0
            if (this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].status === "submitted" && this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].isShown) {
              countSubmitted++;
              bandEnviada = 1;
            }
            if (this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].isShown) {
              countTotal++;

            }
            if(bandEnviada) {
              if (this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].gradingstatus === "notgraded" && this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].isShown) {
                countNotGraded++;
                alumnosNotGrade.push({
                    idAssigment: this.state.submissions[indexSubmission].data.submissions.assignments[0].assignmentid,
                    id: this.state.submissions[indexSubmission].data.submissions.assignments[0].submissions[index].userid,
                    cursoId: this.state.actividades.assigns[indexActividad].course
                })
              }
            }
          }

          countNotSubmitted = countTotal - countSubmitted;
          let actividadName = 'actividad_'+countAct;
          submittedData[actividadName] = countSubmitted;
          //No enviadas
          totalNoEnviadas = conteo - countSubmitted 
          notSubmittedData[actividadName] = totalNoEnviadas;
          notGradedData[actividadName] = countNotGraded;          
          countAct++;
        }
      }
      countSubmitted = 0;
      countNotSubmitted = 0;
      countNotGraded = 0;
      countTotal = 0;
    }
    
    let columnasTablaActividades = [];
    columnasTablaActividades.push({singleStatus: 'Enviada',status:'Enviadas', ...submittedData});
    columnasTablaActividades.push({singleStatus: 'No Enviada',status: 'No Enviadas', ...notSubmittedData},);
    columnasTablaActividades.push({singleStatus: 'No Calificada',status: 'No Calificadas', ...notGradedData},);

    this.setState({dataColumnas: columnasTablaActividades, isLoading: false, alumnosNotGrade: alumnosNotGrade});
    this.props.returnFromChild(this.state);
  }

  async handleClick(status, cantidad, actividad, rowData) {
    let filtroData = [];
    filtroData.push({'status': status, 'cantidad': cantidad, 'actividad': actividad});
    await this.setState({filtro: filtroData});
    this.props.returnFromChild(this.state);
    //let idCard = "resultadosCurso_" + this.state.cursos[index].cursosId;
    let nombreCard = "resultadosCurso_" + this.props.data.cursosId;
    let elemntoTablaCurso = document.getElementById(nombreCard);
    elemntoTablaCurso.scrollIntoView({ behavior: 'smooth' });
  }

  render () {
    return(
      <Dimmer loader active={this.state.isLoading}>
        <div id="tablaEntregas">
        <MaterialTable
          title=""
          columns={this.state.columns}
          data={this.state.dataColumnas}
          options={{
            headerStyle: {
              borderBottom: '2px solid #FF6F00',
            },
            rowStyle: {
              backgroundColor: '#f7f7f7',
            },
            search: false,
            draggable: false,
            paging: false,
            disableGutters: true,
          }}
        />
        </div>
      </Dimmer>
    );
  }
}

export default TablaReporteActividades;